import { EMPTY_MASTER_GROUPANY_MODEL } from "presentation/model/Group/GroupMaintenanceModel"; 
import { useState } from "react"; 
import { createContainer } from "react-tracked"; 
const { 
    Provider: GroupMaintenanceProvider, 
    useTracked: useGroupMaintenanceTracked 
} = createContainer(() => useState(EMPTY_MASTER_GROUPANY_MODEL), {concurrentMode: true}); 
export { GroupMaintenanceProvider, useGroupMaintenanceTracked }; 
